import { Component } from 'react';

class SortingBox extends Component {
  constructor(props) {
    super(props);

    this.upHandler = this.upHandler.bind(this);
    this.downHandler = this.downHandler.bind(this);
    this.selectHandler = this.selectHandler.bind(this);

    this.state = {
      list: [],
      selected: 0
    };
  }

  upHandler() {
    if (this.state.selected <= 0) {
      return;
    }
    const { list } = this.state;
    const itemToSwap = list[this.state.selected];
    list[this.state.selected] = list[this.state.selected - 1];
    list[this.state.selected - 1] = itemToSwap;

    this.setState(prevState => ({
      list,
      selected: prevState.selected - 1
    }));
  }

  downHandler() {
    if (this.state.selected >= this.state.list.length - 1) {
      return;
    }
    const { list } = this.state;
    const itemToSwap = list[this.state.selected];
    list[this.state.selected] = list[this.state.selected + 1];
    list[this.state.selected + 1] = itemToSwap;

    this.setState(prevState => ({
      list,
      selected: prevState.selected + 1
    }));
  }

  selectHandler(index) {
    this.setState(prevState => ({
      selected: index,
      list: prevState.list
    }));
  }
}

export default SortingBox;



// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/SortingBox.js